import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import CruiseSaleAddOnsTable from './add-ons-table';
import CruiseSaleItemDetailTable from './detail-table';
import CruiseSaleGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../../style';

export default function CruiseGuestCard(props: { parentIndex: number }) {
  const { t } = useTranslation();

  return (
    <CardSection>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">{t('ticketSales:guest_detail')}</Text>
        <Input
          type="check-box"
          name={`approvalable.cruiseSales.${props.parentIndex}.isGroupedPrice`}
          label={t('ticketSales:grouped_price')}
          noMargin
        />
      </ScheduleCardHeader>
      <Separator gap={24} />
      <CruiseSaleGuestTable parentIndex={props.parentIndex} />
      <Separator gap={24} />
      <CruiseSaleItemDetailTable parentIndex={props.parentIndex} />

      <CruiseSaleAddOnsTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
